export default __webpack_public_path__ + "static/cndf-cilium-dsr1-7326a3f8c021e167e7964b2b413c69a2.jpg";